import React from 'react';
import { useTranslation } from 'react-i18next';
import FeaturedSectionStats from '../../ui/FeaturedSectionStats';
import './IntroSectionFormationAD.css';

const IntroSectionFormationAD3: React.FC = () => {
  const { t } = useTranslation();

  // Data for FeaturedSectionStats specific to Azure Admin Formation
  const formationStats = [
    {
      value: '21h',
      label: 'Formation intensive',
      translationKey: 'formationAD.stats.duration',
      labelTranslationKey: 'formationAD.stats.durationLabel'
    },
    {
      value: '2 ans',
      label: 'Équivalent terrain',
      translationKey: 'formationAD.stats.experience',
      labelTranslationKey: 'formationAD.stats.experienceLabel'
    },
    {
      value: '100%',
      label: 'Administration sécurisée',
      translationKey: 'formationAD.stats.security',
      labelTranslationKey: 'formationAD.stats.securityLabel'
    },
    {
      value: '∞',
      label: 'Accés aux ressources',
      translationKey: 'formationAD.stats.continuity',
      labelTranslationKey: 'formationAD.stats.continuityLabel'
    }
  ];

  return (
    <div className="intro-section-home intro-section-formation-ad">
      <div className="intro-row-1 tw-grid tw-grid-cols-1 lg:tw-grid-cols-2 tw-gap-8 tw-items-center tw-pt-[4em] max-[734px]:tw-pt-0">
        <div className="intro-text-1">
          <h2 style={{ fontSize: '62px', paddingBottom: '12px' }}>{t('formationAD.introSection.statsTitle', 'Notre engagement')}</h2>
        </div>
      </div>

      <FeaturedSectionStats
        title="Maîtrisez en 21h ce que les entreprises recherchent en 2 ans de terrain."
        subtitle="Nous avons condensé ce savoir-faire en un programme intensif qui transforme vos ingénieurs en une ligne de défense proactive et une force d'accélération pour votre entreprise."
        titleTranslationKey="formationAD.stats.title"
        subtitleTranslationKey="formationAD.stats.subtitle"
        stats={formationStats}
        showChart={false}
      />
    </div>
  );
};

export default IntroSectionFormationAD3;
